import { langs } from "helpers/lang";
import { Language } from "interfaces/locale";
import React from "react";
import { useTranslation } from "react-i18next";
import { LeftArrow, StyledLink } from "./styles";

interface Props {
  color: string;
  to: string;
}

const PrimaryBackButton: React.FC<Props> = ({ color, to }) => {
  const { i18n } = useTranslation();
  const lang = (i18n.language ?? langs.pt) as Language;
  const backlink = lang === langs.pt ? to : `${to}${lang}`;

  return (
    <StyledLink to={backlink}>
      <LeftArrow color={color} />
    </StyledLink>
  );
};

export default PrimaryBackButton;
